import { render, staticRenderFns } from "./CmgOrderConfirmationHeaderMap.vue?vue&type=template&id=8846bd62&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-header-map.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-header-map.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationHeaderMap.vue?vue&type=style&index=0&id=8846bd62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8846bd62",
  null
  
)

export default component.exports